var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 6.667H7c-.8 0-1.333.533-1.333 1.333v1.867l10.667 6L27 10V8c0-.8-.533-1.333-1.333-1.333Z",
    fill: "#10A8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.667 18.533-10-5.6V24c0 .8.533 1.333 1.333 1.333h18.667c.8 0 1.333-.533 1.333-1.333V12.933l-10 5.6c-.373.187-.96.187-1.333 0Z",
    fill: "#10A8BA"
  })));
};
export default SvgMail;